import { render, staticRenderFns } from "./Records.vue?vue&type=template&id=cb5a5eec&"
import script from "./Records.vue?vue&type=script&lang=ts&"
export * from "./Records.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports